module.exports = __webpack_public_path__ + "c172234320e4a393e843a5fe10de5c4b.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1036
// module chunks = 0